import React from "react";

function PriceBlock() {
    return <div className="min-h-12" />;
}

export default PriceBlock;
